module.exports = __webpack_public_path__ + "img/MERS-Green-Black.4b2e7f9d.png";